import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../api/redux-toolkit/reducer/authSlice';

// Admin console only: one `auth` slice. The customer `selector` slice went with
// the vendored customer tree.
export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
